// extracted by mini-css-extract-plugin
export default {"menu":"Menu_menu__2VHeH","open":"Menu_open__OtfGT","pointer":"Menu_pointer__BCJi0"};